module.exports = __webpack_public_path__ + "static/media/book.e6e211fe.png";